import { useKeystoneSession as useStubSession } from '@rtaoutdoorlivingllc/keystone-react';

import { useDevSession } from './use-dev-session';

/**
 * The workspace keystone-react already returns the session shape this app consumes, so this is a
 * pass-through. It stays as a seam: if the app moves back to the published SDK, the field mapping
 * belongs here rather than at 61 call sites.
 *
 * It is also where the dev auth bypass lands. Patching here rather than at AuthGate is what makes
 * RequireRole, the capability helpers and every other consumer agree with the gate — a bypass that
 * only opened AuthGate left guarded routes rendering their empty fallback.
 */
export const useKeystoneSession = (): ReturnType<typeof useStubSession> => {
	const real = useStubSession();
	const { active, session } = useDevSession();

	if (!import.meta.env.DEV || !active || !session) return real;

	// A real token wins: once the provider has bootstrapped one, the genuine session is authoritative.
	return real.status === 'ready' ? real : session as ReturnType<typeof useStubSession>;
};
